import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { treatments } from '../data/treatments';
import { LinkButton } from './ui/Button';
import { Pill } from './ui/Pill';
import { WhatsAppIcon } from './ui/WhatsAppIcon';
import { waLink } from '../utils/whatsapp';
export function Treatments() {
  return <section id="tratamientos" className="border-t border-hairline bg-base py-12 lg:py-20" aria-labelledby="tratamientos-title" data-id="element-300" data-mp="i1fwjhr67bl3">
      <div className="mx-auto max-w-shell px-5 lg:px-[120px]" data-id="element-301" data-mp="m0opikedz5fl">
        <header data-id="element-302" data-mp="r0jg0mu91t04">
          <Pill data-id="element-303" data-mp="r01bz41ciahn">Lo que hacemos</Pill>
          <h2 id="tratamientos-title" className="mt-5 max-w-[600px] font-display text-[26px] font-bold leading-[1.2] text-ink lg:text-[36px]" data-id="element-304" data-mp="vsksa8rf3jq5">
            Tratamientos para cuidar, recuperar y mejorar tu sonrisa.
          </h2>
          <p className="mt-4 max-w-[560px] font-sans text-[17px] leading-[1.6] text-muted" data-id="element-305" data-mp="15slcdwx423ve">
            Desde tu primera consulta hasta el seguimiento, cada tratamiento está pensado para tu caso específico.
          </p>
        </header>

        <ul className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-306" data-mp="1mqh3bydojbat">
          {treatments.map(treatment => {
          const Icon = treatment.icon;
          return <li key={treatment.id} className={`group flex flex-col rounded-2xl bg-white p-7 shadow-soft transition-all duration-200 hover:-translate-y-1 hover:shadow-card ${treatment.urgent ? 'border-l-[3px] border-l-[#FEE2E2]' : ''} border-b-[3px] border-b-transparent hover:border-b-secondary`} data-id="element-307" data-mp="1cs1clwike41u">
                <span className="flex h-11 w-11 items-center justify-center rounded-[10px] bg-mist" data-id="element-308" data-mp="20nm53m6d1o09">
                  <Icon className="h-8 w-8 text-secondary" strokeWidth={1.5} data-id="element-309" data-mp="1vp1e8dd00goh" />
                </span>
                <h3 className="mt-4 font-sans text-[18px] font-semibold text-ink" data-id="element-310" data-mp="2t849yckw6p3u">{treatment.title}</h3>
                <p className="mt-2 font-sans text-[14px] leading-[1.6] text-muted" data-id="element-311" data-mp="mi0vt79msp11">{treatment.description}</p>
                <a href={waLink(treatment.message)} target="_blank" rel="noreferrer" className="mt-4 inline-flex items-center gap-1 font-sans text-[13px] font-medium text-secondary transition-colors hover:text-[#2f9a95]" data-id="element-312" data-mp="rgub958haq3u">
                  Preguntar sobre este tratamiento
                  <ArrowRightIcon className="h-3 w-3" data-id="element-313" data-mp="3q82tcukb3tb" />
                </a>
              </li>;
        })}
        </ul>

        <div className="mt-12 rounded-2xl border border-secondary/25 bg-[#F0F7F7] px-6 py-8 text-center lg:px-10" data-id="element-314" data-mp="3pypuk72z2ug5">
          <p className="font-sans text-[18px] font-semibold text-ink" data-id="element-315" data-mp="3uxaus6i85e4l">¿No sabes qué tratamiento necesitas?</p>
          <p className="mx-auto mt-2 max-w-[420px] font-sans text-[15px] leading-[1.6] text-muted" data-id="element-316" data-mp="1o73akphhzzt6">
            Cuéntanos lo que sientes y te orientamos sin compromiso.
          </p>
          <div className="mt-6 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center" data-id="element-317" data-mp="3do8hzzjqc6md">
            <LinkButton variant="whatsapp" href={waLink('Hola, hace tiempo no voy al odontólogo y quiero retomar mi cuidado dental. ¿Por dónde debo empezar?')} target="_blank" rel="noreferrer" data-id="element-318" data-mp="38q6pko0eyuy8">
              <WhatsAppIcon className="h-5 w-5" data-id="element-319" data-mp="92emzyj1o2q" />
              Escribir por WhatsApp
              <ArrowRightIcon className="h-4 w-4" data-id="element-320" data-mp="3rg56zuq3q0ej" />
            </LinkButton>
            <LinkButton variant="outline" href="#necesidad" className="font-medium" data-id="element-321" data-mp="3ri99q9c9ktd8">
              Ver todos los tratamientos
            </LinkButton>
          </div>
          <p className="mt-4 font-sans text-[12px] italic text-[#9CA3AF]" data-id="element-322" data-mp="598203xrkof0">
            Te orientamos antes de agendar. Sin formularios.
          </p>
        </div>
      </div>
    </section>;
}